<template>
  <b-modal
    v-model="modal_attachments.view"
    size="xl"
    :title="'Ficha de seguridad del producto ' + product_selected.nombre"
    hide-footer
  >
    <div class="" v-for="item in safety_data_sheets" :key="item.type">
      <h4 class="text-center">
        {{ item.type }}
      </h4>
      <b-embed type="iframe" :src="item.file" allowfullscreen></b-embed>
    </div>
  </b-modal>
</template>

<script>
import {mapState } from "vuex";

export default {
  name: "modal_attachments",
  computed: {
    ...mapState("analysis", ["modal_attachments", "product_selected"]),
    ...mapState("productos", ["safety_data_sheets"]),
  },
};
</script>

<style>
.form-input-group {
  height: 32px !important;
}
</style>
